import React from 'react';
import RecipientDetailsCard from './RecipientDetailsCard';
import RecipientDetailsEditCard from './RecipientDetailsEditCard';
import { RecipientTypes } from '../../../lib/systemVariables';
import { PhoneNumberTypes } from '../../../lib/constants';

export default class RecipientAccountDetails extends React.Component {

    getInitialFormattedRecipient = (recipient) => {
        return {
            applicantType: recipient.applicantType,
            isIsraeli: recipient.isIsraeli,
            personTitleId: recipient.personTitleId,
            firstName: recipient.firstName || '',
            lastName: recipient.lastName || '',
            reportName: recipient.reportName || '',
            organization: {
                institutionTitleId: recipient.applicantType === RecipientTypes.Organization && recipient.organization ? recipient.organization.institutionTitleId : null,
                name: recipient.applicantType === RecipientTypes.Organization && recipient.organization ? recipient.organization.name : '',
                registered: recipient.applicantType === RecipientTypes.Organization && recipient.organization ? recipient.organization.registered : false,
                taxId: recipient.applicantType === RecipientTypes.Organization && recipient.organization ? recipient.organization.taxId || '' : '',
            },
            address: recipient.address || {},
            previousAddress: recipient.previousAddress || {},
            phoneNumber: recipient.phoneNumber || '',
            phoneType: recipient.phoneType || (recipient.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American),
            secondPhoneNumber: recipient.secondPhoneNumber || '',
            secondPhoneType: recipient.secondPhoneType || (recipient.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American),
            email: recipient.email || '',
            bankAccounts: recipient.bankAccounts,
            teudatZahut: recipient.teudatZahut || '',
            tags: recipient.tags ? recipient.tags.map(t => t.key) : [],
            references: recipient.references,
            solicitors: recipient.solicitors,
            roshYeshivas: recipient.roshYeshivas,
            trustedPayee: recipient.trustedPayee,
            applicantPledges: recipient.applicantPledges,
            orgEmploymentType: recipient.orgEmploymentType || '',
            orgEmploymentPosition: recipient.orgEmploymentPosition || '',
            orgEmploymentGrade: recipient.orgEmploymentGrade !== 0 ? recipient.orgEmploymentGrade || '' : "0",
            orgEmploymentSeder: recipient.orgEmploymentSeder || ''
        };
    }

    getIncompleteFields = (recipientDetails, setTrustedPayee) => {
        const recipient = recipientDetails || this.getInitialFormattedRecipient(this.props.recipientDetails.data);

        const requiredFields = { recipientInfo: [] };

        if (recipient.applicantType === RecipientTypes.Individual) {
            if (!recipient.firstName) requiredFields.recipientInfo.push('First Name');
            if (!recipient.lastName) requiredFields.recipientInfo.push('Last Name');
        } else {
            if (!recipient.organization.name) requiredFields.recipientInfo.push('Name');
            if (recipient.organization.registered && !recipient.organization.taxId) requiredFields.recipientInfo.push('Tax ID');
        }
        if (recipient.isIsraeli) {
            if (recipient.applicantType === RecipientTypes.Individual && !recipient.teudatZahut) requiredFields.recipientInfo.push('Teudat Zehut');

            if (!recipient.trustedPayee) {
                const activeBankAcct = recipient.bankAccounts.filter(acct => acct.active)[0];
                if (!activeBankAcct) {
                    requiredFields.recipientInfo.push('Active Bank Account');
                } else {
                    if (!activeBankAcct.bankRoutingNumber) requiredFields.recipientInfo.push('Active Bank Account - Bank Number');
                    if (!activeBankAcct.bankBranchNumber) requiredFields.recipientInfo.push('Active Bank Account - Branch Number');
                    if (!activeBankAcct.bankAccountNumber) requiredFields.recipientInfo.push('Active Bank Account - Account Number');
                }
            }
        }
        if (!recipient.tags.length) requiredFields.recipientInfo.push('Categories');
        if (setTrustedPayee && !recipient.trustedPayee) requiredFields.recipientInfo.push('Trusted Payee');
        if (!recipient.address.streetNumber || !recipient.address.street || !recipient.address.city || !recipient.address.country) requiredFields.recipientInfo.push('Address is Incomplete');

        return requiredFields.recipientInfo.length ? requiredFields : null;
    }

    render() {
        return (
            <div>
                {this.props.editMode
                    ? <RecipientDetailsEditCard
                        recipient={this.props.recipientDetails.data}
                        tags={this.props.tags}
                        toggleEditMode={this.props.toggleEditMode}

                        getRecipientAccountDetails={this.props.getRecipientDetails}
                        updateRecipient={this.props.updateRecipient}
                        updateRecipientDetails={this.props.updateRecipientDetails}
                        applicationHistory={this.props.applicationHistory}
                        getApplicationHistory={this.props.getApplicationHistory}
                        getSystemSettings={this.props.getSystemSettings}

                        getInitialFormattedRecipient={this.getInitialFormattedRecipient}
                        getIncompleteFields={this.getIncompleteFields} />
                    : <RecipientDetailsCard
                        recipient={this.props.recipientDetails.data}
                        applicationHistory={this.props.applicationHistory}

                        userId={this.props.userId}
                        permissions={this.props.permissions}
                        isAdmin = {this.props.isAdmin}
                        isApprover = {this.props.isApprover}
                        loading={this.props.recipientDetails.loading}

                        toggleEditMode={this.props.toggleEditMode}
                        disableEditMode={this.props.disableEditMode}

                        addNote={this.props.addNote}
                        updateNote={this.props.updateNote}
                        deleteNote={this.props.deleteNote}
                        updatingNote={this.props.updatingNote}

                        getIncompleteFields={this.getIncompleteFields} />}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientAccountDetails.jsx